// src/utils/mediaTools/isPersistedObject.ts

// True only for real DB ids
export const isPersistedObjectId = (id: unknown): id is number => {
  if (typeof id !== "number") return false;

  // optimistic ids are timestamps (13+ digits)
  // DB ids in MySQL/Postgres will NEVER reach this range
  return id > 0 && id < 1_000_000_000;
};
